<template>
  <div class="edt">
    <v-app-bar
      flat
      color="transparent"
      class="main-appbar"
    >
      <app-bar-nav-icon />
      <div class="d-flex align-center">
        <v-toolbar-title>
          <h1 class="headline font-weight-bold">{{ pageTitle }}
          </h1>
        </v-toolbar-title>
      </div>
      <v-spacer />
      <div>
        <v-btn
          color="primary"
          medium
          @click="onSave"
          :loading="form.$busy"
          style="text-transform: none;"
        >Save</v-btn>
      </div>
    </v-app-bar>
    <v-row class="px-4 py-4">
      <v-col
        lg="8"
        md="6"
        sm="12"
        xs="12"
      >
        <v-card
          outlined
          class="px-6 py-8"
        >

          <v-text-field
            v-model="form.page_header"
            outlined
            label="Page Header Text"
            :error-messages="form.$getError('page_header')"
          />

          <content-editor
            label="Page Sub Header Text"
            v-model="form.page_subheader"
            articleType="freeToPlay"
          />

          <v-textarea
            class="mt-8"
            v-model="form.page_description"
            outlined
            label="Page Description Text"
            :error-messages="form.$getError('page_description')"
          />

           <v-text-field
            outlined
            flat
            label="Page H2"
            v-model="form.subheading_title"
            :error-messages="form.$getError('subheading_title')"
          />

          <v-textarea
            outlined
            name="input-7-4"
            label="Page H2 Copy"
            v-model="form.subheading_description"
            :error-messages="form.$getError('subheading_description')"
          />

        </v-card>
      </v-col>
      <v-col
        lg="4"
        md="6"
        sm="12"
      >
        <games-live
          :gamesAvailable="optionList"
          v-bind:addItems.sync="form.add_podcast_items"
          v-bind:removeItems.sync="form.remove_podcast_items"
          :games="liveItems"
          :liveItemsOrg="liveItems"
          page_title="Podcast Items"
          add_item_text="Add Item"
          dialog_title="Add a Podcast Item"
          dropdown_label="Available Podcast Items"
          v-bind:itemOrder.sync="itemOrder"
        />
        <social-sharing-meta-tag
          class="mt-6"
          v-bind:title.sync="form.seo_title"
          v-bind:description.sync="form.seo_description"
          v-bind:image.sync="form.social_thumbnail"
        />

        <!-- <image-alt-text
          v-if="form.hero_banner"
          v-bind:imageAltText.sync="form.image_alt_text"
        /> -->

      </v-col>
    </v-row>
    <v-overlay
      absolute
      :value="loading"
    >
      <v-dialog
        v-model="loading"
        hide-overlay
        persistent
        width="300"
      >
        <v-card
          color="primary"
          dark
        >
          <v-card-text>
            {{ loading_message }}
            <v-progress-linear
              indeterminate
              color="white"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    <v-snackbar
      v-model="snackbar.show"
      right
      :color="snackbar.color"
    >
      {{ snackbar.message }}
      <v-btn
        text
        @click="snackbar.show = false"
      >OK</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import Form from '@/utils/form'
import get from 'lodash/get'
import head from 'lodash/head'
import isNull from 'lodash/isNull'
import replace from 'lodash/replace'
import Podcast from '@/models/Podcast'
import AppBarNavIcon from '@/layouts/shared/AppBarNavIcon'
import SocialSharingMetaTag from '@/components/SocialSharingMetaTag'
import ImageAltText from '@/components/ImageAltText'
import ContentEditor from '@/components/ContentEditor'
import GamesLive from '@/components/GamesLive'
import { mapState, mapActions } from 'vuex'
import isEmpty from 'lodash/isEmpty'
import Api from '@/services/api'

const initialData = {
  page_header: null,
  page_subheader: null,
  page_description: [],
  seo_title: null,
  seo_description: null,
  social_thumbnail: null,
  add_podcast_items: [],
  remove_podcast_items: [],
  subheading_title: null,
  subheading_description: null
}

export default {

  components: {
    AppBarNavIcon,
    SocialSharingMetaTag,
    ImageAltText,
    ContentEditor,
    GamesLive
  },

  data () {
    return {
      loading: false,
      updating: false,
      loading_message: '',
      snackbar: {
        show: false,
        message: null,
        color: 'success'
      },
      loadingTags: false,
      form: new Form({
        ...initialData
      }),
      liveItems: [],
      itemOrder: []
    }
  },
  props: {
    podcast: {
      type: [Podcast, Object],
      default () {
        return {}
      }
    },
    pageTitle: {
      type: String,
      default: 'Podcast'
    },
    redirectCancelTo: {
      type: [String, Object],
      default () {
        return {
          name: 'podcast'
        }
      }
    },
    redirectSaveTo: {
      type: [String, Object],
      default () {
        return {
          name: 'podcast'
        }
      }
    }
  },

  methods: {
    head,
    replace,
    ...mapActions({
      getList: 'podcastItem/getList'
    }),
    onCancel () {
      this.$router.replace(this.redirectCancelTo)
    },

    async onSave () {
      try {
        const vm = this
        this.form.$busy = true
        this.form.$clearErrors()
        const data = this.form.$data()

        if ((data.social_thumbnail && data.social_thumbnail.id) || isNull(data.social_thumbnail)) { this.$delete(data, 'social_thumbnail') }
        if (isNull(data.image_alt_text)) { this.$delete(data, 'image_alt_text') }
        this.$delete(data, 'id')

        if (isEmpty(data.remove_podcast_items)) {
          this.$delete(data, 'remove_podcast_items')
        }

        if (isEmpty(data.add_podcast_items)) {
          this.$delete(data, 'add_podcast_items')
        }

        const podcast = new Podcast(data)
        await podcast.save()

        await Api.post(`admin/app-podcasts/podcast/reorder`, { podcast_ids: this.itemOrder })

        this.showSnackbar('Updated!', 'success')

        setTimeout(() => {
          vm.$emit('refreshData')
        }, 1000)
      } catch (error) {
        if (get(error, 'response.status') === 422) {
          if (get(error, 'response.data.errors') !== null) {
            this.form.$setErrors(get(error, 'response.data.errors'))
          } else {
            this.showSnackbar('Something went wrong.', 'error')
          }
        } else {
          this.showSnackbar(error, 'error')
        }
      } finally {
        this.form.$busy = false
      }
    },
    showSnackbar (message, color = 'success') {
      this.snackbar.message = message
      this.snackbar.show = true
      this.snackbar.color = color
    },
    async fetcRecordList (page = 1) {
      let params = { page }

      params.sort = '-created_at'
      params.per_page = 'all'
      this.loading = true
      this.loading_message = 'Fetching Live Games List'
      await this.getList(params)
      this.loading = false
    }

  },

  watch: {
    podcast: {
      immediate: true,
      handler (val) {
        if (val) {
          this.form = new Form({
            ...initialData,
            ...val
          })

          if (val.hero_banner) {
            this.form.image_alt_text = val.hero_banner.custom_properties.alt_text
          }

          if (val.podcasts) {
            val.podcasts.forEach((value, key) => {
              this.liveItems.push({
                text: value.title,
                thumbnail: value.thumbnail,
                value: value.id,
                isLiveItem: true
              })
            })
          }
        }
      }
    }
  },

  computed: {

    isModeUpdate () {
      return get(this.form, 'id', null) !== null
    },

    ...mapState({
      optionList: state => state.podcastItem.optionList

    })

  },

  created () {
    this.fetcRecordList()
  }
}
</script>
